export type MeasurementLengthUnit = 'm' | 'km' | 'cm' | 'mm' | 'mi' | 'ft';
export type MeasurementAreaUnit = 'm2' | 'km2' | 'cm2' | 'ha';

const LENGTH_LABELS: Record<MeasurementLengthUnit, string> = {
  m: 'm',
  km: 'km',
  cm: 'cm',
  mm: 'mm',
  mi: 'mi',
  ft: 'ft',
};

const AREA_LABELS: Record<MeasurementAreaUnit, string> = {
  m2: 'm²',
  km2: 'km²',
  cm2: 'cm²',
  ha: 'ha',
};

export function convertLengthMeters(meters: number, unit: MeasurementLengthUnit): number {
  switch (unit) {
    case 'km':
      return meters / 1000;
    case 'cm':
      return meters * 100;
    case 'mm':
      return meters * 1000;
    case 'mi':
      return meters / 1609.344;
    case 'ft':
      return meters * 3.28084;
    default:
      return meters;
  }
}

export function convertAreaSquareMeters(m2: number, unit: MeasurementAreaUnit): number {
  switch (unit) {
    case 'km2':
      return m2 / 1_000_000;
    case 'cm2':
      return m2 * 10_000;
    case 'ha':
      return m2 / 10_000;
    default:
      return m2;
  }
}

export function formatLengthMeters(
  meters: number,
  unit: MeasurementLengthUnit,
  digits = 2,
): string {
  const value = convertLengthMeters(meters, unit);
  return `${value.toFixed(digits)} ${LENGTH_LABELS[unit]}`;
}

export function formatAreaSquareMeters(
  m2: number,
  unit: MeasurementAreaUnit,
  digits = 2,
): string {
  const value = convertAreaSquareMeters(m2, unit);
  return `${value.toFixed(digits)} ${AREA_LABELS[unit]}`;
}
